<template>
    <div  class="page-setting has-bc biz-edit-account-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <!-- <div class="btn-group">
                <button class="default-button publish" @click="saveData">儲存設定</button>
            </div> -->
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                帳號
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        員工帳號
                        </div>
                        <div class="biz-table-content">
                            {{insertData.email?insertData.email:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                基本資料
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        員工真實姓名
                        </div>
                        <div class="biz-table-content">
                            {{insertData.name?insertData.name:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        手機號碼
                        </div>
                        <div class="biz-table-content">
                            {{insertData.phoneNumber?insertData.phoneNumber:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                分配群組
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        職務部門
                        </div>
                        <div class="biz-table-content">
                            {{accountInfo.roleName?accountInfo.roleName:'-'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                        業務分群
                        </div>
                        <div class="biz-table-content">
                            {{accountInfo.groupName?accountInfo.groupName:'-'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            insertData: {
                email: '',
                name: '',
                phoneNumber: '',
                roleId: '',
                groupId: '',
                userId: '',
            },
        }
    },
    mounted () {
        // 取得角色列表
        this.getEmployeeRoleList();
        // 取得分群列表
        this.getOrganizationGroupList();
        // 取得詳細
        this.getInfo(this.$route.query.cId)
        this.insertData.userId = this.$route.query.cId
    },
    watch: {
        accountInfo: {
            handler: function (newValue, oldValue) {
                this.componentKey += 1
                this.insertData.email = this.accountInfo.account
                this.insertData.name = this.accountInfo.name
                this.insertData.phoneNumber = this.accountInfo.phoneNumber
                this.insertData.roleId = this.accountInfo.roleId
                this.insertData.groupId = this.accountInfo.groupId
            },
            deep: true,
        }
    },
    methods: {
        getEmployeeRoleList: function () {
            this.$store.dispatch('getBizEmployeeRoleList')
        },
        getOrganizationGroupList: function () {
            this.$store.dispatch('getBizOrganizationGroupList')
        },
        getInfo: function (id) {
            this.$store.dispatch('getBizAccountInfo', id)
        },
    },
    computed: {
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
            accountInfo: 'GET_BIZ_ACCOUNT_INFO',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
    }
}
</script>
<style lang="scss">
    .biz-edit-account-comp{
        .toggle-block > .toogle-body {
            padding: 0 24px 24px 24px;
        }
        .biz-table{
            .biz-table-row{
                .biz-table-title{
                    width: 85px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/accountMgt/viewAccountComp.vue